import React from 'react'

export const Govideo = () => {
  return (
          <div
        id="go-video"
        className="sc_layouts sc_layouts_popup sc_layouts_12962"
        data-delay={0}
      >
        <div
          data-elementor-type="cpt_layouts"
          data-elementor-id={12962}
          className="elementor elementor-12962"
        >
          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-cf4e536 elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static"
            data-id="cf4e536"
            data-element_type="section"
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-e45dd90 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static"
                data-id="e45dd90"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-eddc457 sc_fly_static elementor-widget elementor-widget-trx_widget_video"
                    data-id="eddc457"
                    data-element_type="widget"
                    data-widget_type="trx_widget_video.default"
                  >
                    <div className="elementor-widget-container">
                      <div className="widget_area sc_widget_video">
                        <aside className="widget widget_video">
                          <div
                            id="sc_video_700027609"
                            className="trx_addons_video_player without_cover"
                          >
                            <div className="video_embed video_frame">
                              <iframe
                                allow="autoplay"
                                data-src="https://www.youtube.com/embed/Vagc5qqm1_o?feature=oembed&%23038%3Bwmode=transparent&%23038%3Borigin=https%3A%2F%2Fagricola.axiomthemes.com&%23038%3Bwidgetid=1&%23038%3Benablejsapi=1&%23038%3Bdisablekb=1&%23038%3Bmodestbranding=1&%23038%3Biv_load_policy=3&%23038%3Brel=0&%23038%3Bshowinfo=0&%23038%3Bplaysinline=1&autoplay=1"
                                width={1290}
                                height={726}
                              />
                            </div>
                          </div>
                        </aside>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
  )
}
